import { css } from "@emotion/css";
import { text } from "@octopusdeploy/design-system-tokens";
import { logger } from "@octopusdeploy/logging";
import { isGitBranch } from "@octopusdeploy/octopus-server-client";
import { useCallback, useEffect, useState } from "react";
import * as React from "react";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
import { useProjectContext } from "~/areas/projects/context/index";
import { repository } from "~/clientInstance";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import ExternalLink from "~/components/Navigation/ExternalLink";
export function ProjectCreatePullRequestLink() {
    const projectContext = useProjectContext();
    const branchProtectionsAreEnabled = isFeatureToggleEnabled("BranchProtectionsFeatureToggle");
    const [pullRequestLink, setPullRequestLink] = useState<string | undefined>(undefined);
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const onPullRequestLinkClicked = useCallback(() => {
        dispatchAction("Create Pull Request");
    }, [dispatchAction]);
    useEffect(() => {
        if (!branchProtectionsAreEnabled || !projectContext.state.gitRef) {
            return;
        }
        repository.Projects.getPullRequestLink(projectContext.state.model, projectContext.state.gitRef.CanonicalName)
            .then((resp) => {
            if (resp.Link) {
                setPullRequestLink(resp.Link);
            }
        })
            .catch((e) => {
            logger.warn(e, "Failed to get pull request link");
        });
    }, [projectContext.state.model, projectContext.state.gitRef, branchProtectionsAreEnabled]);
    if (!projectContext.state.model.IsVersionControlled || !branchProtectionsAreEnabled) {
        return null;
    }
    const currentHead = projectContext.state.gitRef?.CanonicalName;
    const isDefaultBranch = projectContext.state.isDefaultBranch;
    const canCreatePullRequest = isGitBranch(currentHead) && !isDefaultBranch && pullRequestLink;
    return canCreatePullRequest ? (<ExternalLink href={pullRequestLink} onClick={onPullRequestLinkClicked} trackAnalytics={false} className={createPullRequestLinkStyles}>
            Create pull request
        </ExternalLink>) : null;
}
const createPullRequestLinkStyles = css({
    font: text.interface.body.default.medium,
});
